export const emptyRosterFilters = () => ({
    actTypeId: "", lineupCountId: "", vibeIds: [], genreIds: []
});

export const rosterQueryString = (limit, page, criteria = {}) => {
    const query = new URLSearchParams({ limit: String(limit), page: String(page) });
    appendRosterCriteria(query, criteria);
    return query.toString();
};

const appendRosterCriteria = (query, criteria) => {
    if (criteria.search && criteria.search.trim()) query.set("search", criteria.search.trim());
    ["actTypeId", "lineupCountId"].forEach(key => {
        if (criteria[key] !== "" && criteria[key] != null) query.set(key, String(criteria[key]));
    });
    ["vibeIds", "genreIds"].forEach(key => {
        const ids = Array.from(new Set((criteria[key] || []).map(String))).filter(Boolean);
        if (ids.length) query.set(key, ids.join(","));
    });
};

export const rosterFilterQueryString = (criteria = {}) => {
    const query = new URLSearchParams();
    appendRosterCriteria(query, criteria);
    return query.toString();
};
